import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=0c3d600b&scoped=true&"
import script from "./FormFile.vue?vue&type=script&lang=js&"
export * from "./FormFile.vue?vue&type=script&lang=js&"
import style0 from "./FormFile.vue?vue&type=style&index=0&id=0c3d600b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d600b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3d600b')) {
      api.createRecord('0c3d600b', component.options)
    } else {
      api.reload('0c3d600b', component.options)
    }
    module.hot.accept("./FormFile.vue?vue&type=template&id=0c3d600b&scoped=true&", function () {
      api.rerender('0c3d600b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormFile.vue"
export default component.exports